import { MyCoursesActions } from "./MyCourses-slice";
import { uiActions } from "./ui-slice";
import axios from 'axios'
// import '../utils/axios-interceptor'

export const fetchCoursesSearchData = (url_data, token) => {
	// console.log(url_data)
	return async (dispatch) => {
		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const searchData = await fetchData();
			dispatch(MyCoursesActions.updateSearchData(searchData));
		} catch (error) {
			console.log(error);
		}
	};
};

export const fetchEnrolledData = (url_data, token) => {
	console.log("***** fetchEnrolledData *****");
	console.log(url_data);
	return async (dispatch) => {
		dispatch(uiActions.showLoadingSpinner(7));

		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const enrolledData = await fetchData();
			dispatch(MyCoursesActions.updateEnrolledData(enrolledData));
			dispatch(uiActions.hideLoadingSpinner(7));
		} catch (error) {
			console.log(error);
		}
	};
};

export const fetchCompletedData = (url_data, token) => {
	console.log("***** fetchCompletedData *****");
	console.log(url_data);
	return async (dispatch) => {
		dispatch(uiActions.showLoadingSpinner(9));

		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const completedData = await fetchData();
			dispatch(MyCoursesActions.updateCompletedData(completedData));
			dispatch(uiActions.hideLoadingSpinner(9));
		} catch (error) {
			console.log(error);
		}
	};
};

export const fetchRequestsData = (url_data, token) => {
	console.log("***** fetchRequestsData *****");
	// console.log(url_data, token)
	return async (dispatch) => {
		dispatch(uiActions.showLoadingSpinner(8));
		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const requestsData = await fetchData();
			dispatch(MyCoursesActions.updateRequestsData(requestsData));
			dispatch(uiActions.hideLoadingSpinner(8));
		} catch (error) {
			console.log(error);
		}
	};
};

export const deleteEnrollmentRequest = (url_data, url_endpoint, token) => {
	console.log("***** deleteEnrollmentRequest *****");
	// console.log(url_data + url_endpoint);

	return async (dispatch) => {
		const fetchData = async () => {
			const response = await axios.delete(url_data + url_endpoint, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const requestsData = await fetchData();
			console.log(requestsData);
			// dispatch(MyCoursesActions.updateRequestsData(requestsData));
			dispatch(fetchRequestsData(url_data, token));
		} catch (error) {
			console.log(error);
		}
	};
};
